import { useEffect } from 'react'

import {
  useCredentials,
  useSetCredentials,
} from '../components/CredentialsProvider'

import {
  decodeToken,
  getTokenRemainingTimeToExpireInMs,
} from '../services/token'

import { refreshCredential, CredentialResponse } from '../services/api'
import { credentialEvent, refreshTokenThreshold } from '../config'

const useTokenRefresh = () => {
  const credentials = useCredentials()
  const setCredentials = useSetCredentials()

  useEffect(() => {
    let timeoutId = null

    if (credentials.refreshToken && credentials.token) {
      const decodedToken = decodeToken(credentials.token)

      if (decodedToken) {
        const timeRemainingToExpire = getTokenRemainingTimeToExpireInMs(
          credentials.token
        )

        const timeToRefresh = timeRemainingToExpire - refreshTokenThreshold

        timeoutId = setTimeout(() => {
          refreshCredential(credentials.refreshToken)
        }, timeToRefresh)
      }
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [credentials.token, credentials.refreshToken])

  useEffect(() => {
    const handleStorageChange = ({
      detail,
    }: CustomEvent<CredentialResponse>) => {
      const { user, token, refreshToken } = detail

      setCredentials({ authentication: user, token, refreshToken }, 'local')
    }

    window.addEventListener(credentialEvent, handleStorageChange)

    return () =>
      window.removeEventListener(credentialEvent, handleStorageChange)
  }, [setCredentials])
}

export default useTokenRefresh
